import {useEffect, useRef} from 'react'

interface CloseDialogOnBrowserBackOptions {
  closeOnBrowserBack?: boolean
  onClose: (value: boolean) => void
  open?: boolean
}

export const useCloseDialogOnBrowserBack = (options: CloseDialogOnBrowserBackOptions) => {
  const {closeOnBrowserBack, onClose, open} = options

  // The ref is needed because popstate triggers at a weird timing. If we just put onClose into the dependency array
  // of useEffect, the 'popstate' event listener will not fire.
  // This is the best solution I could come up with
  const onCloseRef = useRef(onClose)

  useEffect(() => {
    if (!closeOnBrowserBack || !open) return

    const onPopstate = () => {
      onCloseRef.current(false)
    }
    window.addEventListener('popstate', onPopstate)
    return () => {
      window.removeEventListener('popstate', onPopstate)
    }

  }, [onCloseRef, closeOnBrowserBack, open])
}
